import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchAllSubCategories } from "../../../services/subcategories";
import SubcategoriesHistory from "./SubcategoriesHistory";

const SubcategoriesGridHistory = () => {
  const { t } = useTranslation();
  const [subcategories, setSubcategories] = useState([]);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);

  // Fetch des subcategories
  const fetchSubcategories = async () => {
    try {
      const data = await fetchAllSubCategories();

      // Filtrer uniquement les subcategories archivées
      const archivedSubs = data.filter((sub) => sub.isArchived === true);

      setSubcategories(archivedSubs);
      setFilteredSubcategories(archivedSubs);
      setIsError(false);
    } catch (err) {
      console.error("Erreur fetch subcategories:", err);
      setError("Failed to fetch subcategories. Please try again later.");
      setIsError(true);
    }
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);

  // Filtrage par titre
  useEffect(() => {
    const results = subcategories.filter((sub) =>
      sub.subCategoryDetails.some((detail) =>
        detail.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredSubcategories(results);
  }, [searchTerm, subcategories]);

  console.log("subcategories filteredSubcategories", filteredSubcategories);

  return (
    <Fragment>
      <PageTitle activeMenu={t("subcategories")} motherMenu={t("menu")} />

      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <input
            type="text"
            className="form-control input-rounded"
            placeholder={t("searchByTitle")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-end">
          <Link
            to="/add-subcategory"
            className="btn btn-success btn-block w-auto d-inline-flex align-items-center"
          >
            <i className="fas fa-plus me-2" />
            {t("addNewSubcategory")}
          </Link>
        </div>
      </div>

      <div className="row mt-5">
        {isError || filteredSubcategories.length === 0 ? (
          <div className="col-12">
            <div className="alert alert-warning" role="alert">
              {isError ? error : t("noDataFound")}
            </div>
          </div>
        ) : (
          filteredSubcategories.map((sub) => (
            <SubcategoriesHistory
              key={sub._id}
              subcategory={sub}
              fetchSubcategories={fetchSubcategories}
            />
          ))
        )}
      </div>
    </Fragment>
  );
};

export default SubcategoriesGridHistory;
